module.exports = "https://static.wmbcdn.com/uniweb/images/c7365902658cd957bce8aeb4811dc5e8.svg";